import $ from 'jquery';
import imageUploader from '../components/imageUploader';
import translateService from '../common/translateService';

const init = () => {
    const identifier = 'help-uploader';
    let btn = document.getElementById(identifier);
    if (btn !== null) {
        var galleryUploader = imageUploader.setup({
            id: identifier,
            onComplete: function (id, name, response) {
                $('#' + identifier).after(
                    '<input class="uploadedImages" name="Attachments[' +
                        id +
                        ']" type="hidden" value="' +
                        response.fileSystemId +
                        '">'
                );
            },
            onDeleteComplete: function (id, xhr, isError) {
                if (isError === false) {
                    $("input[name='Attachments[" + id + "]']").remove();
                }
            },
            onSubmitDelete: function (id) {
                var item = $("input[name='Attachments[" + id + "]']");
                if (item.length > 0) {
                    var fileSystemId = item.val();
                    this.setDeleteFileParams(
                        { fileSystemId: fileSystemId },
                        id
                    );
                }
            },
            sizeLimit: 5000000,
            sizeError: translateService.get('helpUploader.messages.sizeError'),
        });

        $('.qq-upload-button-selector.qq-upload-button div').text(
            translateService.get('reviewImages.messages.attachYourImages')
        );
        $('.qq-uploader-selector.qq-uploader.qq-gallery').attr(
            'qq-drop-area-text',
            translateService.get('reviewImages.messages.dropAreaText')
        );
    }
};

export default {
    init,
};
